import { render, staticRenderFns } from "./SideBarItem.vue?vue&type=template&id=25ee60c6&scoped=true"
import script from "./SideBarItem.vue?vue&type=script&lang=js"
export * from "./SideBarItem.vue?vue&type=script&lang=js"
import style0 from "./SideBarItem.vue?vue&type=style&index=0&id=25ee60c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ee60c6",
  null
  
)

export default component.exports